<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30.14 16.67"
  >
    <path
      class="cls-1"
      d="M29.67.47c-.62-.62-1.64-.62-2.26,0l-12.34,12.34L2.73.47C2.11-.16,1.09-.16.47.47-.16,1.09-.16,2.11.47,2.73l13.47,13.47c.23.23.52.38.83.44.1.02.2.03.31.03s.2,0,.31-.03c.3-.06.59-.2.83-.44,0,0,0,0,0,0L29.67,2.73c.62-.62.62-1.64,0-2.26Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
